import { OnboardingWizard } from '@/components/onboarding'

export function OnboardingPage() {
  return <OnboardingWizard />
}
